import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import * as moment from 'moment';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-outlet-master-report',
  templateUrl: './outlet-master-report.component.html',
  styleUrls: ['./outlet-master-report.component.scss']
})
export class OutletMasterReportComponent implements OnInit {
  date ;
  selectedDate : any = ""
   constructor(
     private apiService : ApiService,
     private apiConfig : ApiConfiguration,
     private exportExcelService : ExportExcelService
   ) { 
     let currentDate = new Date()
     this.date = moment(currentDate).format("YYYY-MM-DD")
     this.selectedDate = this.date
   }
 
   ngOnInit() {
   }
 
   
 
   filterListOfRecords(){
     this.apiService.get(this.apiConfig.liveReport + `?program_id=1&date=${this.date}&report_id=22`).subscribe((res : any)=>{
       console.log(res);
       this.downloadExcel(res.data.report_data)
     })
   }


  downloadExcel(data){
    let sheetName = "sheet1";
    let filename = "outlet_master_";
    let excelData = data;
    let excelArray = [
      { header: 'Outlet/Osmosys Code', key: 'outlet_code'},
      { header: 'Outlet Name', key: 'outlet_name'},
      { header: 'Channel',key: 'channel_desc'},
      { header: 'State Name', key: 'state_name'},
      { header: 'Region Name', key: 'region_name'},
      { header: 'M1 User ID', key: 'm1_user_id' },
      { header: 'M1 Name', key: 'm1_name'},
      { header: 'M1 Mobile Number', key: 'm1_mobile_number'},
      { header: 'M2 User ID', key: 'm2_user_id'},
      { header: 'M2 Name', key: 'm2_name'},
      { header: 'M2 Mobile Number',key: 'm2_mobile_number'},
      { header: 'M3 User ID',key: 'm3_user_id'},
      { header: 'M3 Name', key: 'm3_name'},
      { header: 'M3 Mobile Number',    key: 'm3_mobile_number'},
    ]
    this.exportExcelService.DownloadstaticReportExcel(filename, sheetName, excelData, excelArray);
  }

}
 
 
 